__webpack_require__.p = "/sidebar-expander-shortcuts/onboarding/";